import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { FeatureEnum } from '../../models/program-api-models';

@Injectable({
  providedIn: 'root',
})
export class FeatureService {
  http = inject(HttpClient);

  async isFeatureEnabled(feature: FeatureEnum): Promise<boolean> {
    try {
      return await firstValueFrom(this.http.get<boolean>(`feature/${feature}`));
    } catch (error) {
      throw new Error('Failed to check feature. Please try again.');
    }
  }
}
